import { render, staticRenderFns } from "./LawMatterTypeSubFolderForm.vue?vue&type=template&id=32cae5ae&"
import script from "./LawMatterTypeSubFolderForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterTypeSubFolderForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterTypeSubFolderForm.vue?vue&type=style&index=0&id=32cae5ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports